<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { ref } from 'vue';
import ChevronRight from '~icons/lucide/chevron-right';

const revealed = ref(false);

defineProps<{ title: string }>();
</script>

<template>
  <section class="image-card" :data-revealed="revealed" @click="() => (revealed = !revealed)">
    <slot name="bg" />

    <div class="cover">
      <div>
        <h1>{{ title }}</h1>
      </div>

      <Button variant="outline" size="xl">
        <span>More</span>
        <ChevronRight class="size-6" />
      </Button>
    </div>

    <div class="content text-content">
      <slot />
    </div>
  </section>
</template>

<style>
.image-card {
  @apply relative flex items-center justify-center text-white bg-black rounded-lg overflow-hidden cursor-pointer;

  > img,
  > video {
    @apply absolute object-cover w-full h-full opacity-60 transition-opacity duration-300;
  }

  > .cover {
    @apply absolute inset-0 select-none flex flex-col gap-20 items-center justify-center rounded-lg;

    > div,
    > button {
      z-index: 1;
    }

    > div {
      @apply text-7xl font-bold text-center; /* mix-blend-difference */
    }

    > button {
      @apply text-xl;
    }

    &:hover > button {
      @apply bg-white/30;
    }
  }

  > .content {
    @apply p-8 text-lg opacity-0 pointer-events-none transition-opacity duration-300;
    z-index: 1;
  }

  &[data-revealed='true'] {
    > img,
    > video {
      @apply opacity-20;
    }

    > .cover {
      @apply hidden;
    }

    > .content {
      @apply opacity-100 pointer-events-auto;
    }
  }
}
</style>
